module.exports = {
  templateUrl: 'main/components/appointment-additional-info/appointment-additional-info.html',
  bindings: {
    appointment: '<',
  },
  controller: class AppointmentAdditionalInfo {
  },
};



// WEBPACK FOOTER //
// ./main/components/appointment-additional-info/appointment-additional-info.js